import React from "react";

import "./About.scss";

import { motion } from "framer-motion";
import { useState } from "react";
import { useEffect } from "react";


import { AppWrap, MotionWrap ,  } from "../../wrapper";

import { urlFor, client } from "../../client";

const About = () => {
  // const abouts = [
  //   {
  //     title: "Front-end",
  //     description: "I am good Web Designer.",
  //     imgUrl: images.about01,
  //   },
  //   {
  //     title: "Back-end",
  //     description: "I have self-confident with my Back-end .",
  //     imgUrl: images.about02,
  //   },
  //   {
  //     title: "Full-stack",
  //     description: "I am good Web Developer.",
  //     imgUrl: images.about03,
  //   },
  //   {
  //     title: "Web UX/UI",
  //     description: "I am good Designer.",
  //     imgUrl: images.about04,
  //   },
  // ];

  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';
    client
      .fetch(query)
      .then((data) => setAbouts(data))
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <h2 className="head-text">
        I Know that <span>Good Dev</span> <br /> means{" "}
        <span>Good Business</span>{" "}
      </h2>
      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 style={{ marginTop: 20 }} className="bold-text">
              {" "}
              {about.title}{" "}
            </h2>
            <p style={{ marginTop: 10 }} className="p-text">
              {" "}
              {about.description}{" "}
            </p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(MotionWrap(About,'app__about'), "about" , "app__whitebg");
